import { Link } from 'react-navi';

export const link: any = {
  component: Link, // Use the react-navi Link component as a baseline
};
